import { MagicBellProvider } from '@magicbell/react-headless';
import { MAGIC_BELL_TOKEN } from 'src/config';
import { useUser } from 'src/hooks/query/userHooks';
import HeadlessNotificationsDrawer from './HeadlessNotificationsDrawer';
import { useMagicBellHMACKey } from 'src/hooks/query/magicbellHooks';

// ----------------------------------------------------------------------

function HeadlessNotificationsPopover() {
  const { data: currentUser } = useUser();
  const { data: magicBellHMACResponse } = useMagicBellHMACKey();

  if (!currentUser || !magicBellHMACResponse) return null;

  return (
    <>
      {currentUser && (
        <MagicBellProvider
          apiKey={MAGIC_BELL_TOKEN || ''}
          userEmail={currentUser?.email || ''}
          stores={[{ id: 'inbox', defaultQueryParams: {} }]}
          userKey={magicBellHMACResponse.hmac_key}
        >
          <HeadlessNotificationsDrawer />
        </MagicBellProvider>
      )}
    </>
  );
}

export default HeadlessNotificationsPopover;
